import { Box, Typography, Button, Grid, Card } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../global";
import Footer from "../components/HomeComponent/Footer";
import SafetyTimeline from "../components/cleaningStandardComponent/safetyTimeline";
import News from "../components/globalCountries/countryhomepagescomponent/News";
import FreeDeliveryBanner from "../components/HomeComponent/FreeDeliveryBanner";

const CleaningStandardsPage = () => {
  const { t } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const services = [
    {
      content:
        "Contactless Pickup & Delivery to reduce physical interaction.",
    },
    {
      content: "Daily Disinfection of machines, tables, and vehicles.",
    },
    {
      content:
        "Daily Temperature Checks for all staff.",
    },
    {
      content:
        "Disinfectants are used in every wash cycle.",
    },
    {
      content:
        "Global Hygiene Standards followed (WHO & CDC).",
    },
    {
      content:
        "Separate Storage Sections to prevent cross-contamination.",
    },
    {
      content:
        "All staff wear Protective Gear.",
    },
    {
      content:
        "High-temperature drying kills 99.9% of bacteria.",
    },
    {
      content:
        "Individual Wash Loads for each customer.",
    },
    {
      content:
        "Clear Communication of all safety practices.",
    },
  ];

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: { xs: "280px", md: "440px" },
          bgcolor: "#F2F3F0",
        }}
      >
        <Box
          component="img"
          src={`${imageBaseUrl}cleaningStandard.svg`}
          alt=""
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            left: 0,
            top: 0,
            display: {
              xs: "none",
              sm: "none",
              md: "block",
            },
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pl: { sm: "30%" },
          }}
        >
          <Typography
            sx={{
              textTransform: "uppercase",
              textAlign: "center",
              textShadow: "0 2px 8px rgba(0,0,0,0.26)",
              fontFamily: globalStyles.fonts.primaryUAE,
              fontWeight: 600,
              fontSize: {
                md: "55px",
                sm: "36px",
                xs: "30px",
              },
              lineHeight: { md: "60px", sm: "40", xs: "35px" },
              letterSpacing: "1%",
              color: globalStyles.colors.army_green,
              px: 2,
            }}
          >
            Cleaning
            <br /> Standards
          </Typography>
        </Box>
      </Box>

      {/* ✅ Cards Section (OUTSIDE heroTextBox now) */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          px: {
            xs: 1,
            sm: 2,
          },
          py: 8,
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            width: "100%",
            mx: "auto", // horizontally center
            px: { xs: 2, sm: 4 }, // horizontal padding on small screens
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: globalStyles.colors.medium_gray,
              textAlign: "center",
              mb: 4,
              fontSize: {
                xs: "16px",
                sm: "20px",
                md: "20px",
              },
            }}
          >
            Health and cleanliness matter more than ever; our enhanced cleaning standards guarantee every item is returned fresh, clean, and safe.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { md: "row", sm: "column", xs: "column" },
            gap: 4,
            alignItems: "center",
            my: 10,
          }}
        >
          <Box sx={{ width: { md: "50%" },maxWidth:"1200px" }}>
            <Box
              sx={{
                textAlign: {
                  xs: "center", // center on mobile
                  md: "left", // keep default on desktop
                },
                px: { xs: 2 }, // padding for mobile view
              }}
            >
              <Typography
                variant="h1_gothic"
                sx={{
                  textTransform: "uppercase",
                  fontFamily: globalStyles.fonts.primaryUAE,
                  fontWeight: 600,
                  fontSize: {
                    md: "40px",
                    sm: "28px",
                    xs: "24px",
                  },
                  color: globalStyles.colors.text_green,
                  letterSpacing: "1%",
                  lineHeight: "auto",
               
                }}
              >
               Hygiene and Safety First
              </Typography>
            </Box>

            <Box
              sx={{
                maxWidth: "1200px",
                width: "100%",
                px: { xs: 2, sm:2  }, // only horizontal padding on mobile
                textAlign: { xs: "center", sm: "left" }, // center on mobile, normal on tablet/desktop
              }}
            >
              <Typography
                sx={{
                  fontFamily: globalStyles.fonts.primary,
                  fontSize: {
                    sm: "20px",
                    xs: "16px",
                  },
                  color: globalStyles.colors.medium_gray,
                  lineHeight: {
                    xs: "auto", // better than 'auto'
                    sm: "auto",
                  },
                  letterSpacing: "1%", // better rendering than "1%"
                  my: 2.5,
                }}
              >
                At UClean, hygiene has always been our top priority. Every garment is handled with the highest care, delivering 100% clean and sanitised clothes with a strong focus on health and safety.
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "center",
                  sm: "flex-start",
                },
                px: { xs: 2, sm:2  },
              }}
            >
              <Button
                sx={{
                  color: globalStyles.colors.uclean_green,
                  border: `1px solid ${globalStyles.colors.uclean_green}`,
                  borderRadius: "10px",
                  px: 6,
                  py: 0.75,
                  mt: 2,
                  textTransform: "none",
                  fontFamily: globalStyles.fonts.primary,
                  fontSize: {
                    sm: "18px",
                    xs: "14px",
                  },
                  fontWeight: 600,
                  height: "fit-content",
                  "&:hover": {
                    backgroundColor: globalStyles.colors.uclean_green,
                    color: globalStyles.colors.white,
                  },
                }}
              >
                Learn More About Us
              </Button>
            </Box>
          </Box>
          <Box sx={{ width: { md: "50%", sm: "100%", xs: "100%" } }}>
            <Box
              component="iframe"
              src="https://www.youtube.com/embed/mGK035nCbLI"
              title={t("leadership.videoTitle")}
              sx={{
                width: "100%",
                height: {
                  xs: "300px",
                  sm: "400px",
                  md: "400px",
                },
                border: 0,
                borderRadius: "10px",
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: globalStyles.colors.base_light,
          py: {
            xs: 4,
            md: 10,
          },
          px: {
            xs: 2,
          },
          mt: {
            xs: "-15%",
            md: 0,
          },
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: "center",
              fontFamily: globalStyles.fonts.primaryUAE,
              fontWeight: 600,
              px: 4,
              fontSize: "40px",
              color: "#053B26",
              textTransform: "uppercase",
              mb: 6,
            }}
          >
          Cleaning Standards at Uclean
          </Typography>

          <Box>
            <Grid container spacing={2} sx={{ justifyContent: "center" }}>
              {services.map((service, index) => (
                <Grid item xs={12} sm={6} lg={3} key={index}>
                  <Card
                    sx={{
                      display: "flex",
                      gap: 3,
                      border: "1px solid",
                      borderColor: "grey.200",
                      borderRadius: "10px",
                      py: 2.5,
                      px: 4,
                      height: "100%",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "#e0f2e9", // light green background on hover
                        borderColor: "#003A26", // dark green border on hover
                      },

                      "@media (hover: none)": {
                        "&:active": {
                          backgroundColor: "#e0f2e9", // same effect for mobile tap
                          borderColor: "#003A26",
                        },
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={`${imageBaseUrl}dry.png`}
                      alt={service.title}
                      sx={{
                        width: "50px",
                        height: "auto",
                        objectFit: "contain",
                        borderRadius: 1,
                      }}
                    />
                    <Box>
                      <Typography
                        sx={{
                          fontSize: {
                            sm: "18px",
                            xs: "14px",
                          },
                          color: globalStyles.colors.medium_gray,
                          fontFamily: globalStyles.fonts.primary,
                        }}
                      >
                        Step {index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: {
                            sm: "16px",
                            xs: "12px",
                          },
                          color: globalStyles.colors.army_green,
                          mt: { xs: 1, sm: 1.5 },
                          letterSpacing: "0%",
                          lineHeight: {
                            sm: "20px",
                            xs: "15px",
                          },
                        }}
                      >
                        {service.content}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: globalStyles.colors.army_green,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "scroll",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: globalStyles.colors.white,
          position: "relative",
          overflow: "hidden",
          minHeight: {
            xs: "96px",
            sm: "110px",
            md: "120px",
            lg: "140px",
            xl: "160px",
          },
          py: {
            xs: 4,
            sm: 4,
            md: 6,
          },
          px: {
            xs: 1,
          },
        }}
      >
        <Typography
          variant="h1_gothic"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "24px", sm: "38px", md: "40px" },
            color: globalStyles.colors.white,
            textAlign: "center",
            lineHeight: 1.3,
            textTransform: "uppercase",
            maxWidth: "1000px",
            position: "relative",
            zIndex: 2,
            letterSpacing: "1%",
          }}
        >
          Global LEADERS IN Laundry and Dry Cleaning SERVICES
        </Typography>
      </Box>
      <SafetyTimeline />
      {/* Promo/Banner/News */}
      <FreeDeliveryBanner />
      <News />
      <Box sx={{ height: "80px" }} />
      <Footer />
    </Box>
  );
};

export default CleaningStandardsPage;
